import React from 'react';
import Grid from '@material-ui/core/Grid'
import styled from 'styled-components'
import { H3 } from '../typography/H3';

// styled components
const StatusGrid = styled(Grid)`
  width: 'fit-content';
  padding: '0 10px';
  margin-bottom: 15px;
`;

const StatusMsg = styled.div`
  flex: 1;
  font-size: 20px;
  font-weight: bold;
  padding-left: 12px;
  color: ${({theme, available}) => available ? theme.PRIMARY_COLOR : theme.ORANGE};
`;

const Details = styled.div`
  font-size: 14px;
  
  a {
    color: ${({theme}) => theme.SECONDARY_COLOR};
    font-weight: bold;
  }
`;

const Container = styled.div`
  background-color: white;
  padding: 10px 14px;
`;

const Status = ({available}) => {

  let icon = available ? 'success.svg' : 'alert-circle.svg';

  return (
    <StatusGrid container alignItems="center">
      <img height="25" src={require(`assets/images/${icon}`).default} />
      <StatusMsg available={available}>
        {
          available ?
          'EB5AN Regional Center Sponsorship Available' :
          'Create a New Regional Center'
        }
      </StatusMsg>
    </StatusGrid>
  );
}

const RegionalCenter = ({rcName, rcLink}) => {

  let available = !!rcName;

  return (
    <div style={{maxWidth: 1200, margin: '20px auto'}}>
      <H3 style={{marginTop: 27}}>Regional Center Sponsorship</H3>
      <Container>
        <div>
          <Status available={available} />
          <Details>
            {
              available ?
              <>
                This address is covered by the <a href={rcLink} target="_blank">{rcName}</a> and is eligible for immediate project sponsorship.
                <br/><br/>
                <a href="https://eb5affiliatenetwork.com/what-is-an-eb-5-regional-center/" target="_blank">EB-5 regional center</a> designation is a U.S. government license that allows sponsored EB-5 projects to receive favorable EB-5 job calculation treatment, reducing the immigration risk for EB-5 investors.
                <br/><br/>
                Historically, more than 90% of all EB-5 projects have been sponsored by an EB-5 regional center. If a project is located within the approved geographic area of an EB-5 regional center, then it can be sponsored by that EB-5 regional center.
                <br/><br/>
                <a href="https://eb5affiliatenetwork.com/services/" target="_blank">Learn more</a> about EB-5 regional center sponsorship or&nbsp;
                <a href="https://go.oncehub.com/JeremyShackle3" target="_blank">schedule a free consultation</a> to speak with our team today.
              </>
              :
              <>
                This address is not located within one of our approved EB-5 regional centers. We can work with you to create your own EB-5 regional center that will cover this location.
                <br/><br/>
                <a href="https://eb5affiliatenetwork.com/what-is-an-eb-5-regional-center/" target="_blank">EB-5 regional center</a> designation is a U.S. government license that allows sponsored EB-5 projects to receive favorable EB-5 job calculation treatment, reducing the immigration risk for EB-5 investors.
                <br/><br/>
                Historically, more than 90% of all EB-5 projects have been sponsored by an EB-5 regional center. If a project is located within the approved geographic area of an EB-5 regional center, then it can be sponsored by that EB-5 regional center. 
                <br/><br/>
                <a href="https://eb5affiliatenetwork.com/services/" target="_blank">Learn more</a> about EB-5 regional center sponsorship or&nbsp;
                <a href="https://go.oncehub.com/JeremyShackle3" target="_blank">schedule a free consultation</a> to speak with our team today.
              </>
            }
          </Details>
        </div>
      </Container>
    </div>
  );
}

export default RegionalCenter;
